<template>
  <div>
    <report-header @generate="load" @filterChanged="filterChanged"
      @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup"
      :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged" @onChangedTypeDocuments="onChangedTypeDocuments"
      @limitChanged="limitChanged"
      @download="download"
      @downloadAs="downloadAs"
      @onChangeAccsGroup="onChangeAccsGroup"
      />

      <basic-table
        @Filtred="Filtred"
        :items="documents"
        :fields="documentsFields"
        :filter="filter"
        :per-page="perPage"
        :current-page="currentPage"
        @RowSelected="onRowSelected"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import download from '@/utils/downloadFile'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        accs_group_id: 0,
        type: 0,
        limit: 500,
        download: 0
      },
      documents: [],
      documentsFields: [
        //  for default appearence
        // {key: 'id',col_show_default: false, label: this.$i18n.t('Internal number'), sortable: true},
        {key: 'id', label: this.$i18n.t('Internal number'), sortable: true},
        {key: 'alt_id', label: this.$i18n.t('Alternative number'), sortable: true},
        {key: 'ext_num', label: this.$i18n.t('External number'), sortable: true},
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'full_name', label: this.$i18n.t('FullName'), sortable: true},
        {key: 'kpp', label: this.$i18n.t('Reg code'), sortable: true},
        {key: 'tax', label: this.$i18n.t('ITIN'), sortable: true},
        {key: 'year', label: this.$i18n.t('Year'), sortable: true},
        {key: 'month', label: this.$i18n.t('Month'), sortable: true},
        {key: 'time', label: this.$i18n.t('Time'), sortable: true},
        {key: 'is_payed', label: this.$i18n.t('Paid'), sortable: true},
        {key: 'total_sum_with_tax',
          label: this.$i18n.t('Total (incl. taxes)'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'total_tax',
          label: this.$i18n.t('Tax total'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'total_sum',
          label: this.$i18n.t('Charges without tax total'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'odt_created', label: this.$i18n.t('Creation date'), sortable: true, formatter: (val, key, item) => { return !val ? this.$i18n.t('Not installed') : this.$root.showDataWithTZDelta(val) }},
        {key: 'odt_modified', label: this.$i18n.t('Modification date'), sortable: true, formatter: (val, key, item) => { return !val ? this.$i18n.t('Not installed') : this.$root.showDataWithTZDelta(val) }},
        {key: 'status', label: this.$i18n.t('Status'), sortable: true},
        {key: 'mailed', label: this.$i18n.t('Is mailed'), sortable: true}
      ],
      isGenerateDisabled: false,
      selectGroup: 0,
      selectAccsGroup: 0,
      selectTypeDocuments: 1,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: true,
        isFilterAccsGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: true,
        isFilterTypeUsers: false,
        isFilterCollector: false,
        isDownloadable: true,
        isActions: true
      },
      rowSelected: null
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    onRowSelected (rowObj) {
      this.rowSelected = rowObj
    },
    downloadAs (docType) {
      if (!this.rowSelected) {
        this.$root.$emit('makeToasts', 'danger', this.$t('Row is not selected'), 'Error')
      }
      let fileName = 'bill_' + this.rowSelected.uid + '.' + docType
      let payload = {
        file_type: docType === 'odt' ? 0 : 1,
        user_id: this.rowSelected.uid,
        base_id: this.rowSelected.id,
        doc_type: this.selectTypeDocuments
      }
      let response = this.$store.dispatch('Users/GET_REPORT_DOCUMENT', payload)
      response.then(response => {
        download(response.data, fileName, 'application/' + docType)
      })
    },
    async load (isGenerateClick = true) {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      this.getStore.type = this.selectTypeDocuments
      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
        this.getStore.accs_group_id = this.selectAccsGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_DOCUMENTS', this.getStore).then(response => {
        if (isGenerateClick) { this.documents = this.$store.getters['Reports/DOCUMENTS'] } else {
          download(this.$store.getters['Reports/DOCUMENTS'], 'report_payments_documents.csv', 'text/csv')
        }
        for (let el of this.documents) {
          let time = JSON.parse(JSON.stringify(el.invoice_date))
          el.time = this.$root.getMomentWithTZDelta(Number(time)).format('YYYY-MM-DD HH:mm')
          el.year = this.$root.getMomentWithTZDelta(Number(time)).format('YYYY')
          el.month = this.$root.getMomentWithTZDelta(Number(time)).format('MM')

          if (el.is_payed === 1) {
            el.is_payed = true
          } else {
            el.is_payed = false
          }

          if (el.is_pdf_mailed > 0 || el.is_odt_mailed > 0) {
            el.mailed = true
          } else {
            el.mailed = false
          }

          switch (el.odt_status) {
            case -1:
              el.status = this.$i18n.t('Not created')
              break
            case 0:
              el.status = this.$i18n.t('Created')
              break
            case 1:
              el.status = this.$i18n.t('Modified')
              break
            case 2:
              el.status = this.$i18n.t('Deleted')
              break
            default:
              el.status = this.$i18n.t('Unknown')
              break
          }
        }
        this.loadDone()
        this.totalRows = this.documents.length
        this.$emit('input', this.totalRows)
      })
    },
    download () {
      this.getStore.download = 1
      this.load(false)
      this.$store.dispatch('Reports/CLEAR_DOCUMETNS')
      this.getStore.download = 0
      this.totalRows = 0
      this.documents = []
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    onChangeAccsGroup (value) {
      this.selectAccsGroup = value
    },
    onChangedTypeDocuments (value) {
      this.selectTypeDocuments = (value)
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/payments/documents/main.vue